<!-- Nav Menu -->

<template>
  <div id="app" class="overflowPage">
    <Menu :route="route" :config="env"/>
    <transition name="fade" appear>
      <router-view
        :config="env"
        :key="$route.fullPath"
    /></transition>
    <div class='foot'>
      <b-row>
        <b-col>
          <span class='footList'>
          <p class="tptText">
             ©  {{new Date().getFullYear()}} Tartan Pro Tour
          </p>
          </span>
        </b-col>
        <b-col>
          <span class='copyRight'>
            <a href="https://ocs-sport.com" target='_blank'>
              <div class="logoCen">
                <img class="LogoOCS" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Sport_white.png">
                <p>Powering Websites,<br> Data, Apps & Systems</p>
              </div>
            </a>
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>
.tptText {
  text-transform: initial;
  margin-top: 10em; 
  padding-left: 30px;
}
.logoCen.Mob {
  text-align: left;
  font-size: 9pt;
  position: relative;
  top: -15px;
}
.logoCen {
  text-align: right;
  font-size: 9pt;
  position: relative;
  top: -15px;
  color: #fff;
}
.overflowPage {
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14pt;
}
li.nav-item::marker {
  color: transparent;
}
.footList{
  text-transform: capitalize;
    font-size: 9pt;
}
.foot{
  color: #fdfff7;
    background-color: #1A2337;
}
.copyRight{
    float: right;
    margin-top: 1.3em;
    padding-right: 30px;
}
.ocsLogo{
    width: 50px;
    margin-bottom: 20px;
    display: block;
    position: relative;
}
@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}
</style>
<script>
  <meta name="apple-itunes-app" content="app-id=1522698750"></meta>
</script>
<script>
import Menu from "@/components/menu.vue";

export default {
  components: {
    Menu,
  },
  data() {
    return {
      env:[]
    };
  },
  mounted() {
    this.env = process.env
  },
  computed:{
    route(){
      return this.$router.history.current.path
    }
  },
  methods: {
    // Define method that will use the payload to update the data property
    setSeason(payload) {
      this.season = payload.season;
    },
    setCourse(payload) {
      this.course = payload.course;
    },
    setReport(payload) {
      this.currentReport = payload.currentReport;
    },
    setTitle(payload) {
      this.currentTitle = payload.currentTitle;
    },
  },
};
</script>
